import React, { useEffect, useRef, useState } from "react";
import { apiUrl } from "../../../utils/endPoints/apiUrl";
import DeleteHandler from "../../../component/comman/DeleteHandler";
import { PageInfoHeader } from "../../../component/comman/PageInfoHeader";
import { getCoupons } from "../../../action/couponAction";
import { fDateUTC } from "../../../utils/helper/timeHelpers";
import CustomModal from "../../../component/comman/CustomModal";
import AddEditCoupon from "./AddEditCoupon";
import Pagination from "../../../comman/Pagination";   // ✅ ADD THIS

const _modelName = {
  add: "Add",
  edit: "Edit",
};

const CouponListing = () => {
  const [isLoading, setIsLoading] = useState(false);
  const [coupons, setCoupons] = useState([]);
  const [total, setTotal] = useState(0);
  const [page, setPage] = useState(1);
  const limit = 10;
  const [search, setSearch] = useState("");
  const [debouncedSearch, setDebouncedSearch] = useState("");
  const deleteRef = useRef(null);

  const [model, setModel] = useState({ name: "", data: {} });

  const handleModalOpen = (name, data = {}) =>
    setModel({ ...model, name, data });
  const handleModalClose = () => setModel({ ...model, name: null, data: {} });

  useEffect(() => {
    const handler = setTimeout(() => setDebouncedSearch(search), 300);
    return () => clearTimeout(handler);
  }, [search]);

  const fetchCoupon = async () => {
    try {
      handleModalClose();
      setIsLoading(true);

      const resp = await getCoupons({
        offset: (page - 1) * limit,
        limit,
        searchQ: debouncedSearch,
      });

      if (resp?.success) {
        setCoupons(resp.data.rows);
        setTotal(resp.data.total);
      }
    } catch (error) {
      console.log(error);
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    fetchCoupon();
  }, [page, debouncedSearch]);

  return (
    <section className="content mb-5">
      <div className="container-fluid">
        {/* HEADER */}
        <div className="row titlepad">
          <div className="col-md-12">
            <div className="mt-3 mb-3">
              <div className="dashbed-border-bottom"></div>
            </div>

            <div className="row align-items-end">
              <div className="col-sm-9">
                <h4>Coupons</h4>

                <PageInfoHeader
                  page={page}
                  limit={limit}
                  total={total}
                  label="List of coupons"
                />

                <a
                  onClick={() => handleModalOpen(_modelName.add)}
                  className="btn-md btn-primary d-inline-block"
                  style={{ cursor: "pointer" }}
                >
                  <i className="fa-solid fa-user-plus"></i> Add More
                </a>
              </div>

              <div className="col-md-3">
                <input
                  className="form-control searchinput"
                  type="text"
                  placeholder="Search By Coupon.."
                  onChange={(e) => {
                    setSearch(e.target.value);
                    setPage(1);
                  }}
                />
              </div>
            </div>
          </div>
        </div>

        {/* TABLE */}
        <div className="row">
          <div className="col-md-12">
            <div className="mb-3">
              <div className="dashbed-border-bottom"></div>
            </div>
          </div>

          <div className="col-md-12">
            <div className="table-responsive bg-white">
              <table className="table table-striped table-bordered admintable border-0">
                <tbody>
                  <tr>
                    <th>#</th>
                    <th>Purpose/Title</th>
                    <th>Code</th>
                    <th>Used</th>
                    <th>Discount</th>
                    <th>Max Limit</th>
                    <th>Validity</th>
                    <th>Created On</th>
                    <th>Status</th>
                    <th>Action</th>
                  </tr>

                  {isLoading ? (
                    <tr>
                      <td colSpan={10} className="text-center py-4">
                        Loading...
                      </td>
                    </tr>
                  ) : coupons?.length > 0 ? (
                    coupons.map((coupon, index) => (
                      <tr key={coupon._id}>
                        <td>{(page - 1) * limit + (index + 1)}</td>
                        <td>{coupon?.purpose || "--"}</td>
                        <td>{coupon?.couponCode || "--"}</td>
                        <td>{coupon?.noOfTimesUsed || 0}</td>
                        <td>
                          {coupon?.discount
                            ? coupon.discountType === "FIXED"
                              ? `$${coupon.discount}`
                              : `${coupon.discount}%`
                            : "--"}
                        </td>
                        <td>{coupon?.maxUsageLimit || "--"}</td>

                        <td>
                          {fDateUTC(coupon?.validFrom, null, "DD MMM YYYY")} →{" "}
                          {fDateUTC(coupon?.validTo, null, "DD MMM YYYY")}
                        </td>

                        <td>{fDateUTC(coupon?.createdAt, null, "DD MMM YYYY")}</td>

                        <td>
                          <span
                            className={`badge ${
                              coupon.status === "ACTIVE"
                                ? "badge-success"
                                : "badge-danger"
                            }`}
                          >
                            {coupon.status}
                          </span>
                        </td>

                        <td>
                          <a
                            onClick={() =>
                              handleModalOpen(_modelName.edit, coupon)
                            }
                            className="f-16 mr-2"
                            style={{ cursor: "pointer" }}
                          >
                            <i className="fa-solid fa-pen-to-square"></i>
                          </a>

                          <DeleteHandler
                            ref={deleteRef}
                            heading="Confirm Delete"
                            content="Are you sure you want to delete this coupon?"
                            apiUrl={apiUrl.coupons.couponListing}
                            id={coupon?._id}
                            showTriggerButton={false}
                            onDelete={() => fetchCoupon()}
                          />

                          <a
                            className="text-danger f-16"
                            style={{ cursor: "pointer" }}
                            onClick={(e) => {
                              e.preventDefault();
                              deleteRef.current?.openModal();
                            }}
                          >
                            <i className="fa-solid fa-trash-can"></i>
                          </a>
                        </td>
                      </tr>
                    ))
                  ) : (
                    <tr>
                      <td colSpan={10} className="text-center py-4">
                        No coupons found.
                      </td>
                    </tr>
                  )}
                </tbody>
              </table>
            </div>

            {/* ✅ PAGINATION */}
            <div className="text-center mt-4">
              <Pagination
                page={page}
                limit={limit}
                total={total}
                onPageChange={(newPage) => setPage(newPage)}
                showAlways={true}
              />
            </div>

          </div>
        </div>
      </div>

      {/* MODAL */}
      <CustomModal
        width={50}
        open={[_modelName.add, _modelName.edit]?.includes(model?.name)}
        title={
          model.name === _modelName.add ? `Add Coupon` : `Edit Coupon`
        }
        onClose={handleModalClose}
      >
        <AddEditCoupon data={model.data} onAction={fetchCoupon} />
      </CustomModal>
    </section>
  );
};

export default CouponListing;
